import { render } from "./App.vue?vue&type=template&id=3d08e296"
const script = {}

import "./App.vue?vue&type=style&index=0&id=3d08e296&lang=scss"

import exportComponent from "D:\\www\\gt_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__